import React from 'react';
import ComingSoon3D from './ComingSoon3D';

function App() {
  return <ComingSoon3D />;
}

export default App;
